import http from './axiosInstance'
import errorHandler from '../transformers/axiosErrors'
import { ApiResponse, PasswordResetDto, FeedbackDto } from '@/types'

export const resetPassword = async (
  resetDto: PasswordResetDto
): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }

  try {
    const response = await http.put('/account/password', resetDto)

    resp.data = response.data
  } catch (e) {
    resp.error = errorHandler(e)
    if (resp.error.message === 'validation.password') {
      resp.error.message =
        'Your current password was incorrect. Please try again.'
    }
  }
  return resp
}

export const verifyToken = async (
  email: string,
  token: string
): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }

  try {
    const response = await http.put('/account/password/verifyToken', {
      email,
      token,
    })

    resp.data = response.data
  } catch (e) {
    resp.error = errorHandler(e)
  }

  return resp
}

export const forgotPassword = async (email: string): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }

  try {
    const response = await http.put('/account/password/forgot', {
      email,
    })

    resp.data = response.data
  } catch (e) {
    resp.error = errorHandler(e)
  }

  return resp
}

export const cancelSubscription = async (
  subscriptionId: any,
  feedback: FeedbackDto
): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }

  try {
    const response = await http.delete(`/subscriptions/${subscriptionId}`, {
      data: feedback,
    })

    resp.data = response.data
  } catch (e) {
    resp.error = errorHandler(e)
  }

  return resp
}

export const endTrialSubscription = async (
  subscriptionId: number,
  promo?: string,
): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }

  try {
    const response = await http.post(`/subscriptions/${subscriptionId}/end-trial`, {
      promo
    })

    resp.data = response.data
  } catch (e) {
    resp.error = errorHandler(e)
  }

  return resp
}

export const verifyEmail = async (): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }

  try {
    const response = await http.post(`/account/verifyEmail`)
    resp.data = response.data
  } catch (e) {
    resp.error = errorHandler(e)
  }

  return resp
}

export const verifyEmailToken = async (
  email: string,
  emailVerificationToken: string
): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }

  try {
    const response = await http.put('/account/email/verifyToken', {
      email,
      token: emailVerificationToken,
    })

    resp.data = response.data
  } catch (e) {
    resp.error = errorHandler(e)
  }

  return resp
}

export const clients = async (): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }

  try {
    const response = await http.get(`/account/clients`)
    resp.data = response.data
  } catch (e) {
    resp.error = errorHandler(e)
  }

  return resp
}
